module.exports = __webpack_public_path__ + "img/bottom-right.930e5e3.jpg";